import CaseInformationArizona from './CaseInformationArizona';

export default CaseInformationArizona;
